import { CLIENT_ACTIVITY_REPORTS } from '../types';

const initialState = {
  loading: true,
  reports: [],
  dateRange: null,
};

const cientActivityReportsReducers = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CLIENT_ACTIVITY_REPORTS.LOADING_START:
      return {
        ...state,
        reports: [],
        loading: true,
      };
    case CLIENT_ACTIVITY_REPORTS.SET_DATE:
      return {
        ...state,
        dateRange: payload,
      };

    case CLIENT_ACTIVITY_REPORTS.FETCH_SUCCESS:
      return {
        ...state,
        reports: payload,
        loading: false,
      };
    case CLIENT_ACTIVITY_REPORTS.FETCH_FAILED:
      return {
        ...state,
        reports: [],
        loading: false,
      };

    default: {
      return state;
    }
  }
};

export default cientActivityReportsReducers;
